import api from '../api/axios';

export const servicePackageService = {
  async getAll() {
    const response = await api.get('/service-packages');
    return response.data.data;
  },

  async getOne(id: number) {
    const response = await api.get(`/service-packages/${id}`);
    return response.data.data;
  },

  async getByCode(code: string) {
    const response = await api.get(`/service-packages?filters[code][$eq]=${code}`);
    return response.data.data;
  },

  async create(data: any) {
    const response = await api.post('/service-packages', { data });
    return response.data.data;
  },

  async update(id: number, data: any) {
    const response = await api.put(`/service-packages/${id}`, { data });
    return response.data.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/service-packages/${id}`);
    return response.data;
  }
};

